/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const personBrowseItemSchema = z.object({
  id: z.number(),
  slug: z.string(),
  name: z.string(),
  avatarPath: z.string().nullable().optional(),
  knownForDepartment: z.string().nullable().optional(),
  playableChallengesCount: z.number(),
});

export type IPersonBrowseItem = z.infer<typeof personBrowseItemSchema>;

export const browsePeopleResponseSchema = createApiResponseSchema(
  z.array(personBrowseItemSchema),
) as import('zod').ZodSchema<IAPI<IPersonBrowseItem[]>>;

export type IBrowsePeopleResponse = IAPI<IPersonBrowseItem[]>;
